export type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE';

interface RequestOptions<T> {
  method: HttpMethod;
  body?: T;
  headers?: HeadersInit;
}

// const BASE_URL = process.env.GATSBY_API_BASE_URL || '';
const BASE_URL =
  process.env.LIVAT_APP_WRAPPER_FUNCTION_URL ||
  process.env.GATSBY_LIVAT_APP_WRAPPER_FUNCTION_URL;
// const BASE_URL = 'https://qa.booking.livat.com/';
// const BASE_URL = 'https://stage2.livat.com/';

async function request<TResponse, TBody = unknown>(
  endpoint: string,
  options: RequestOptions<TBody>,
): Promise<TResponse> {
  const { method, body, headers } = options;

  const response = await fetch(`${BASE_URL}${endpoint}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  if (!response.ok) {
    const errorBody = await response.json();
    throw {
      status: response.status,
      message: errorBody?.message || 'Unknown API error',
      raw: errorBody,
    };
  }

  return response.json() as Promise<TResponse>;
}

export const api = {
  get: <TResponse>(endpoint: string, headers?: HeadersInit) =>
    request<TResponse>(endpoint, { method: 'GET', headers }),

  post: <TResponse, TBody = unknown>(
    endpoint: string,
    body: TBody,
    headers?: HeadersInit,
  ) => request<TResponse, TBody>(endpoint, { method: 'POST', body, headers }),

  put: <TResponse, TBody = unknown>(
    endpoint: string,
    body: TBody,
    headers?: HeadersInit,
  ) => request<TResponse, TBody>(endpoint, { method: 'PUT', body, headers }),

  delete: <TResponse>(endpoint: string, headers?: HeadersInit) =>
    request<TResponse>(endpoint, { method: 'DELETE', headers }),
};
